export default {
  // Usage based values:
  heading: 300,
  body: 400,
  lowContrast: 600,

  // Literal values (try to avoid as much as possible):
  light: 300,
  regular: 400,
  semibold: 600,
  bold: 700,
};
